import React from 'react';
import { services } from '../data/mock';
import { Helmet } from "react-helmet";

const Services = () => {
  return (
    <section className="services-modern" id="services">
      <div className="section-header-modern">
        <span className="section-label-modern">ENGINEERING SERVICES</span>
        <h2 className="section-title-modern">Advanced Manufacturing Capabilities</h2>
      </div>

      <div className="services-modern-list">
        {services.map((service, index) => (
          <div 
            key={service.id} 
            className={`service-modern-item ${service.alignment === 'right' ? 'reverse' : ''}`}
          >
            <div className="service-modern-image">
              <img 
                src={service.image} 
                alt={service.title}
                className="service-img-modern"
              />
              <div className="service-image-overlay"></div>
            </div>
            
            <div className="service-modern-content">
              <div className="service-number">{String(index + 1).padStart(2, '0')}</div>
              <h3 className="service-modern-title">{service.title}</h3>
              <p className="service-modern-description">{service.description}</p>
              
              {service.materials && (
                <div className="service-modern-detail">
                  <span className="detail-label-modern">Materials</span>
                  <p className="detail-text-modern">{service.materials}</p>
                </div>
              )}
              
              {service.capabilities && (
                <div className="service-modern-detail">
                  <span className="detail-label-modern">Capabilities</span>
                  <ul className="capability-list-modern">
                    {service.capabilities.map((cap, idx) => (
                      <li key={idx}>{cap}</li>
                    ))}
                  </ul>
                </div>
              )}
              
              <div className="service-modern-detail">
                <span className="detail-label-modern">Applications</span>
                <p className="detail-text-modern">{service.applications}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
